module.exports = __webpack_public_path__ + "img/37_02.f10a94c3.png";